module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ltXTK"))).then(() => module.bundle.root('jnagv'));